import { render, staticRenderFns } from "./Uebersicht.vue?vue&type=template&id=c977577a&"
import script from "./Uebersicht.vue?vue&type=script&lang=js&"
export * from "./Uebersicht.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports